import { getServerEnv, type ServerEnv } from '@/shared/lib/api'

const config: Record<
  Exclude<ServerEnv, 'production'>,
  { label: string; bg: string }
> = {
  local: { label: 'LOCAL', bg: '#f59e0b' },
  staging: { label: 'STAGING', bg: '#0678B6' },
}

export function EnvRibbon() {
  const env = getServerEnv()
  if (env === 'production') return null

  const { label, bg } = config[env]

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        bottom: 28,
        left: -40,
        zIndex: 9999,
        width: 150,
        textAlign: 'center',
        transform: 'rotate(45deg)',
        backgroundColor: bg,
        color: '#fff',
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.1em',
        lineHeight: '24px',
        boxShadow: '0 1px 3px rgba(0,0,0,.3)',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {label}
    </div>
  )
}
